// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".memberTab.link:after{display:none}.memberTab svg{margin-left:10px}.memberTab svg path{transition:.6s}.memberTab.link:hover svg path{fill:#ed1651}", ""]);
// Exports
module.exports = exports;
